import { enAuth } from '../en';
import { frAuth } from '../fr';
import { esAuth } from '../es';
import { deAuth } from '../de';

export const authModuleTranslations = {
  en: enAuth,
  fr: frAuth,
  es: esAuth,
  de: deAuth,
} as const;

